export default {
    getMessages(state){
        return state.messages;
    },   
    getItemsValidity(state){
        return state.itemValidity;
    }, 
    getItemUse(state){
        return state.itemUse;
    }, 
    getNewMessageCount(state)
    {
        return state.newMessage
    }
}